<template>
    <div>
      <div>
        <div class="c-card-body">
          <datatable
            ref="datatable"
            module="class-booking"
            :title="title"
            :url="url"
            :columns="columns"
            :on-click-update="onClickUpdate"
            :on-click-delete="onClickDelete"
            :disable-create="true"
            :action-width="180"
            :filter="[{ column: 'class_schedule_id', value: id }]"

          >
             <template v-slot:[`item.created_at`]="{ item }">
                <div v-if="item.created_at != null">
                  {{ item.created_at | moment("DD/MM/YYYY HH:mm") }}
                </div>
                <div v-else>-</div>
            </template>
            <template
              v-if="!loading"
              v-slot:action
            >
              <v-col md="3">
                <v-btn
                  depressed
                  class="ma-1"
                  color="primary"
                  small
                  @click="onClickCreate()"
                >
                  <v-icon small left>mdi-plus</v-icon>
                  Tambah 
                </v-btn>
              </v-col>
            </template>
            <template v-slot:item.is_present="{ item }">
                <!-- label -->
                <v-chip
                  :color="item.is_present ? 'green' : 'red'"
                  text-color="white"
                  small
                >
                  {{ item.is_present ? "Hadir" : "Tidak Hadir" }}
                </v-chip>
            </template>
          </datatable>
        </div>
      </div>
      <form-booking ref="formBooking" :classScheduleId="id" :success="formSuccess" />
      <delete-dialog
        ref="delete"
        url="class-booking"
        :success="deleteSuccess"
      ></delete-dialog>
    </div>
  </template>
  
  <script>
  import Datatable from "@/view/component/Datatable.vue";
  import DeleteDialog from "@/view/component/DeleteDialog.vue";
  import FormBooking from "./FormBooking";
  
  export default {
    data() {
      return {
        title: "User",
        url: "class-booking/data?id=" + this.id,
        columns: [
          {
            value: "id"
          },
          {
            text: "Member",
            value: "member_name",
            sortable: true,
            searchable: true,
          },
          {
            text: "Kehadiran",
            value: "is_present",
            sortable: true,
            searchable: false,
          },
          {
          text: "Created At",
          value: "created_at",
          sortable: true,
          searchable: false,
          formatter: (value) => {
            return value ? this.$moment(value).format("DD/MM/YYYY") : "";
          }
        },

        ],
        data: [],
        loading: true
      };
    },
    props: {
      id: String,
    },
    methods: {
      onClickCreate() {
        this.$refs.formBooking.open(this.id);
      },
      onClickUpdate(item) {
        this.$refs.formBooking.open(this.id, item.id);
      },
      onClickDelete(item) {
        this.$refs.delete.open(item.id);
      },
      formSuccess() {
        this.$refs.datatable.getData();
      },
      deleteSuccess() {
        this.$refs.datatable.getData();
      }
    },
    mounted() {
      this.$watch(
        () => {
          return this.$refs.datatable.items;
        },
        val => {
          this.data = val;
          this.loading = false;
        }
      );
    },
    components: {
      Datatable,
      DeleteDialog,
      FormBooking
    }
  };
  </script>
  